function cov_189gbcxzbs() {
  var path = "/app/src/components/v2/typography/index.ts";
  var hash = "f8164a737d9fd1f2f07a6d4b3ded12c8c4429605";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/v2/typography/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f8164a737d9fd1f2f07a6d4b3ded12c8c4429605"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_189gbcxzbs = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_189gbcxzbs();
export { Typography } from './typography';